<template>
  <div class="grid-container" style="min-height:70vh">
    <div class="grid-x grid-margin-x grid-padding-x mt-50">
        <div class="cell small-12 large-offset-3 large-6 mt-50 mb-50">
          <div class="text-center">
            <h1 class="big-title">Kontakt</h1>
          </div>
          <div class="text mt-50 mb-50">
            ERGO Beratung und Vertrieb AG<br>
            ERGO-Platz 1<br>
            40198 Düsseldorf<br>
            Vertriebsunterstützung Lebensversicherung Telefon: 0211/477 - 4638<br>
            (Mo.-Do. 8:00 Uhr – 19:00 Uhr, Fr.: 8:00 – 17:00 Uhr)<br>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'partnerPolicy',
  components: {
    
  },
  data() {
    return {
      state: this.$store.state,
      ui: {

      }
    }
  },
  async mounted() {
    this.$sleep(300)
    window.scrollTo(0,0)
    this.$store.trackingView("Kontakt");
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="stylus" scoped>
.big-title {
  font-family: 'FedraSerifAPro'
  font-size 3.5em
  line-height: 1.2
  font-weight bold
  color #8E0038

  @media screen and (max-width: 39.9375em) {
    font-size 2.2em
  }
}

</style>